/* global define:true, document: true, window: true */

/*
 * AJAX requests are scattered through the view JS code, so this module is
 * loaded from app.js to listen to the global AJAX error event:
 * http://api.jquery.com/ajaxError/
 *
 * Note: This handler is not called for cross-domain script and cross-domain
 * JSONP requests.
 *
 * To test: use a bookmarklet to add buttons to the DOM which will trigger
 * messages for confirm session, expired session, and ajax error:
 *
 *		javascript:(function(){var $sessionBtns=$('<p><center><button type="button"
 *		class="btn btn-secondary" data-trigger="testSessionMessageConfirm">Confirm
 *		Message</button> <button type="button" class="btn btn-secondary"
 *		data-trigger="testSessionMessageExpire">Expire Message</button> <button
 *		type="button" class="btn btn-secondary"
 *		data-trigger="testSessionMessageError">Error
 *		Message</button></center></p>');$sessionBtns.insertBefore('h1');})();
 *
 * Author: Tim Sullivan
 */

define([
	'jquery',
	'underscore',
	'BaseView',
	'backbone',
	'widgets/theoverpanel',
	'neff',
	'nougat'
], function ($, _, BaseView, Backbone, overpanelView, neff, nougat) {

	'use strict';

	var DEFAULT_RETRIES_AVAILABLE = 0;

	var AjaxErrorView = BaseView.extend({
		el: '#js_ajaxErrorOverpanel',

		template: 'widgets/ajaxError',

		retriesAvailable: DEFAULT_RETRIES_AVAILABLE,

		// signifies if the user is clicking away and aborted requests can be ignored
		isUnloading: false,

		events: {
			'click .tryAgain': function (event) {
				event.preventDefault();
				window.location.reload(true); // use 'forceget' flag
			}
		},

		initialize: function () {
			this.model = new Backbone.Model({
				hideClose: true
			});

			/**
			 * We have to do this because the router hasn't been instantiated, so nougat's context doesn't exist yet.
			 * But don't worry, setContext will merge properties, not override them.
			 */
			nougat.setContext($(document.body).data());

			// this renders the view template up-front so it's always available
			// in it's own private overpanel even without net connection
			this.render();

			// listen for the window.onbeforeunload event that indicates the page has been unloaded
			$(window).bind('beforeunload',
				$.proxy(this.handleUnloadEvent, this)
			);

			// listen for global ajax error event, but make sure unload event can run first
			$(document).ajaxError(
				$.proxy(this.handleError, this)
			);

			if (neff.isEnabled('test-session-messages')) {
				// allow a trigger that will display the error message.
				// This is used for functional testing
				$('#contents').on('click', '[data-trigger="testSessionMessageError"]',
					$.proxy(this.displayAlert, this)
				);
			}
		},

		retryAjax: function (settings) {
			$.ajax(settings)
				.complete($.proxy(function (jqXHR, textStatus) {
					if (textStatus === 'success') {
						this.retriesAvailable = DEFAULT_RETRIES_AVAILABLE; // reset retry counter
					}
				}, this));
		},

		displayAlert: function () {
			// save reference to current overpanel el
			var referenceEl = overpanelView.$el;

			// break Esc key, only way to dismiss is through primary action button
			overpanelView.canUseEsc = false;

			// clear any spinners
			overpanelView.toggleLoading(false)
				// clear overpanel contents while in error state
				.clearContents()
				// change the element that this overpanel works on
				.setElement(this.$el)
				// suppress automatic rendering of the content since it's already rendered
				.setContent(this, {suppressRender: true})
				// show error
				.showOverpanel();

			// Hide the original overpanel DOM element, so that the Ajax Error and normal overpanel don't stack on the
			// page at the same time
			referenceEl.hide();

			// suppress future attempts to rerender due to responses from calls that are in flight when error triggers
			overpanelView.isRenderEnabled = false;
		},

		/**
		 * Event handler for the window.beforeunload event
		 * Flags valid user-aborted requests so error handler can ignore these types of errors.
		 */
		handleUnloadEvent: function () {
			this.isUnloading = true;
		},

		handleError: function (event, jqxhr, settings, exception) {
			var newPath = false; // if we are in a redirect scenario, this will be set to a URL path string

			/*
			 * Flag for turning off the Ajax error handler
			 *
			 * Set the key `ignoreErrors` to true on the $.ajax() settings Object.
			 * E.g. `$.ajax({type: 'GET', url: 'http://www.paypal.com', ignoreErrors: true});`
			 */
			if (settings.ignoreErrors) {
				return false;
			}

			if (jqxhr.status === 401 || jqxhr.status === 302) {
				// redirect user to URL provided in JSON response.
				try { // don't let 401 string response explode JSON.parse
					// redirect user to URL provided in JSON response.
					newPath = $.parseJSON(jqxhr.responseText).location; // try/catch will handle all parse errors
				} catch (e) {
					newPath = jqxhr.getResponseHeader('location'); // if JSON.parse fails due to non-JSON object, extract the location header.
				}

				// if a new path was successfully retrieved from the responseText, do a redirect
				// otherwise, retry logic will take over
				if (newPath) {
					window.location.href = newPath;
					return false; // exits the function if the JSON stuff worked
				}
			}

			if (this.retriesAvailable > 0) {
				this.retriesAvailable = this.retriesAvailable - 1;

				// retry the ajax call after 200ms
				window.setTimeout($.proxy(this.retryAjax, this, settings), 200);
			} else {
				// Show overpanel for legitimate server side errors and
				// connection errors, not for aborted requests

				// setTimeout to avoid race condition that could happen rarely
				window.setTimeout(function afterUnloadEventHandler() {
					// ignore aborted requests
					if (!this.isUnloading) {
						/*
						 *	triggering 'trackError' for ajaxError with mapping of
						 *	message --> exception (adding 'ajaxError' text to differentiate the error in tracking)
						 *	code --> jqhr.status,
						 *	fieldId --> settings.url & settings.type
						 */
						Backbone.trigger('trackError', {
							message: 'ajaxError ' + exception,
							code: jqxhr.status,
							fieldId: settings.url + ', ' + settings.type
						});
						this.displayAlert();
					}

					// reset retry counter in case the modal is dismissed
					this.retriesAvailable = DEFAULT_RETRIES_AVAILABLE;
				}.bind(this), 0);
			}
		}

	});

	return new AjaxErrorView();
});



//////////////////
// WEBPACK FOOTER
// ./widgets/ajaxError.js
// module id = 883
// module chunks = 0